import React, {Component} from 'react';
import Post from '../components/Post';
import { database } from '../firebase';
import randomstring from 'randomstring';

class Posts extends Component {
constructor(props) {
    super(props);
    this.database = database.ref().child('posts');
    this.state = {
      posts: [],
      loadPosts: [
        {
          postTitle: "Yükleniyor...",
          postContent: "Yükleniyor...",
          postDate: 0,
          postImage: "/default.jpg",
          postAuthor: "asdf",
          id: "id"
        }
      ]
    };
    this.addPost = this.addPost.bind(this);
}

componentWillMount() {
    const previousPosts = this.state.posts;
    this.database.on('child_added', snap => {
        previousPosts.push({
            id: snap.key,
            postTitle: snap.val().postTitle,
            postContent: snap.val().postContent,
            postDate: snap.val().postDate,
            postImage: snap.val().postImage,
            postAuthor: snap.val().postAuthor,
        })

        for (let i = previousPosts.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [previousPosts[i], previousPosts[j]] = [previousPosts[j], previousPosts[i]];
        }
        
        this.setState({
            posts: previousPosts,
        })
    })
}

addPost(post) {
    this.database.child(randomstring.generate(20)).set({postTitle: post.postTitle,
                              postContent: post.postContent,
                              postDate: post.postDate,
                              postImage: post.postImage,
                              postAuthor: post.postAuthor,
                            });
    //this.database.child().push({
    //    id: firebase.auth().currentUser.uid,
    //    liked: false
    //});
}

render() {return (
  <>
    {this.state.posts.length > 0 ? this.state.posts.map((post) => (
      <Post postContent={post.postContent}
            postTitle={post.postTitle}
            postDate={post.postDate}
            postImage={post.postImage}
            postAuthor={post.postAuthor}
            postId={post.id}
            key={post.id}/>
    )).reverse() : <img src="/loading.svg" style={{marginTop: "72px"}} className="loading-non"/>}
  </>
)}};

export default Posts;